import { Input, Textarea } from '@/components/ui'
import { formatDate, formatPrice } from '@/utils/formatters'
import { getInterventionStatusLabel, getMaterielStatusLabel, getFacturationStatusLabel } from '@/features/interventions/interventionsSlice'

export default ({ intervention }) => {
  return (
    <div className="bg-base-200 p-4">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">

        <div>
          <Input.Display label="Prestataire" value={intervention?.prestataire?.nom_complet || ''} />
          { intervention?.date_intervention &&
            <Input.Display label="Date de l'intervention" value={formatDate(intervention?.date_intervention || '')} />
          }
          { intervention?.montant &&
            <Input.Display label="Montant" value={formatPrice(intervention?.montant || '')} />
          }
        </div>
      
        <div>
          <Textarea.Display label="Détail de l'intervention" value={intervention?.details || ''}
            className='flex flex-col items-start'
          />
        </div>

        <div>
          <Input.Display 
            label="Statut de l'intervention" 
            value={intervention?.statut ? 
              getInterventionStatusLabel(intervention.statut) : 
              '' 
            }
          />
          { intervention?.statut_materiel && 
            <Input.Display 
              label="Statut du matériel" 
              value={intervention?.statut_materiel ? 
                getMaterielStatusLabel(intervention.statut_materiel) : 
                ''
              } 
            />
          }
          { intervention?.statut_facturation && 
            <Input.Display 
              label="Statut de la facturation" 
              value={intervention?.statut_facturation ?
                getFacturationStatusLabel(intervention.statut_facturation) : 
                ''
              } 
            />
          }
        </div> 
      </div>
    </div>
  )
}